import { PieChart } from "@mui/x-charts"
import PieChartIcon from '@mui/icons-material/PieChart';
import { ccyFormat } from "../../../../../utils/currencyFormatter";
import { H6, Body2, H5, Body1 } from "../../../../../themes/typography";

export default function RevenueGenerated({
    data = []
}) {

    const hasData = data && data.length > 0 && data.some(item => item.value > 0);

    const total = data?.map((item) => item.value)?.reduce((a, b) => a + b, 0);
    const totalRevenue = data?.map((item) => item.revenue)?.reduce((a, b) => a + b, 0);

    const getArcLabel = (params) => {
        const percent = params?.value / total;
        return `${(percent * 100).toFixed(2)}%`;
    };


    return (
        <div className="revenue-generated-container">

            <div className="revenue-generated-wrapper">

                <div className="revenue-generated-content">
                    <div className="revenue-generated-title">
                        <H6 fontWeight={600}>
                            Revenue Generated
                        </H6>
                    </div>
                    <div className="revenue-generated-pie-chart">
                        {/*    <PieChart
                            series={[
                                {
                                    paddingAngle: 3,
                                    innerRadius: '50%',
                                    outerRadius: '100%',
                                    data,
                                    arcLabel: getArcLabel,
                                    valueFormatter: (v, { dataIndex }) => {
                                        const { revenue, value } = data[dataIndex];
                                        return `₹${revenue.toLocaleString()} | Qty: ${value}`;
                                    }
                                },
                            ]}
                            sx={{
                                '& .MuiPieArcLabel-root': {
                                    fontSize: '0.875rem',
                                },
                            }}
                            colors={[
                                '#8884d8',
                                '#82ca9d',
                                '#ffc658',
                                '#ff8042',
                                '#00C49F',
                                '#0088FE',
                                '#FFBB28',
                                '#FF8042',
                            ]}
                            slots={{
                                legend: () => null,
                            }}
                        /> */}
                        {hasData ? (
                            <PieChart
                                series={[
                                    {
                                        paddingAngle: 3,
                                        innerRadius: '50%',
                                        outerRadius: '100%',
                                        data,
                                        arcLabel: getArcLabel,
                                        valueFormatter: (v, { dataIndex }) => {
                                            const { revenue, value } = data[dataIndex];
                                            return `₹${revenue.toLocaleString()} | Qty: ${value}`;
                                        },
                                    },
                                ]}
                                sx={{
                                    '& .MuiPieArcLabel-root': {
                                        fontSize: '0.875rem',
                                    },
                                }}
                                colors={[
                                    '#8884d8',
                                    '#82ca9d',
                                    '#ffc658',
                                    '#ff8042',
                                    '#00C49F',
                                    '#0088FE',
                                    '#FFBB28',
                                    '#FF8042',
                                ]}
                                slots={{
                                    legend: () => null,
                                }}
                            />
                        ) : (
                            <div className="no-system-alerts">
                                <div className="no-system-alerts-icon">
                                    <PieChartIcon sx={{ fontSize: "3rem", marginLeft: '0 !important' }} color="inherit" />
                                </div>
                                <Body1 fontWeight={400}>
                                    No revenue data available.
                                </Body1>
                                <Body2 color="var(--secondary-color)" fontWeight={350}>
                                    Revenue data will be displayed here once tickets are sold.
                                </Body2>
                            </div>
                        )}
                    </div>
                </div>

                {hasData && (
                    <div className="revenue-generated-values">
                        <Body2>
                            Total Revenue
                        </Body2>

                        <H5 fontWeight={600} color="var(--secondary-color)">
                            {ccyFormat(totalRevenue)}
                        </H5>
                    </div>
                )}
            </div>

        </div>
    )
}